<template>

    <b-modal id="bv-modal-remove-card" hide-footer>
      <template #modal-title>Remove card</template>

        <div class="pb-3">How many legs does a cow have?</div>

      <div class="row">
        <div class="col">
            <input type="text" placeholder="Answer here" class="form-control2" v-model="content" @paste.prevent>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
            <button type="button" class="btn btn-danger col" @click="hideModalRemoveCard()">Cancel</button>
        </div>
        <div class="col">
            <button v-if="updating" type="button" class="btn btn-success col">
            <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
            <button v-else type="button" class="btn btn-danger submit col" @click="saveEmail">Continue</button>
        </div>
      </div>

    </b-modal>

</template> 

<script>
export default {
  props: ['card'],

  data() {
    return {
      updating: false,
      content: null,
    };
  },

  methods: {

    clearContent() {
      this.content = null;
    },

    hideModalRemoveCard() {
      this.$bvModal.hide('bv-modal-remove-card');
    },

            saveEmail() {

              if (this.content == null || this.content == '') {this.sweetfire('Enter the answer')}
              else if (!/^four$/i.test(this.content) && this.content != '4') {this.sweetfire('Wrong answer')}

            else {

              this.updating = true;

              axios.post('/billing/remove-card', {
                card: this.card})
                .then((response) => {

                  if (response.data.success) {
                    this.$emit('card-updated');
                    this.hideModalRemoveCard();
                  } else {
                    this.sweetfire(response.data.message);
                  }

                  this.updating = false;

                });

          }

      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  },
};
</script>

<style scoped>
input.form-control, input.form-control:focus {
  border-radius: 5px !important;
}
</style>